var $dc46bea2f2597899$exports = {};
$dc46bea2f2597899$exports = {
  "alpha": "Alfa",
  "black": "negru",
  "blue": "Albastru",
  "blue purple": "albastru-violet",
  "brightness": "Luminozitate",
  "brown": "maro",
  "brown yellow": "galben maro",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "bleu",
  "cyan blue": "albastru-bleu",
  "dark": "\xEEnchis",
  "gray": "gri",
  "grayish": "cenu\u0219iu",
  "green": "Verde",
  "green cyan": "verde bleu",
  "hue": "Nuan\u021B\u0103",
  "light": "deschis",
  "lightness": "Luminozitate",
  "magenta": "fucsia",
  "magenta pink": "roz-fucsia",
  "orange": "portocaliu",
  "orange yellow": "galben-portocaliu",
  "pale": "pal",
  "pink": "roz",
  "pink red": "roz-ro\u0219u",
  "purple": "violet",
  "purple magenta": "violet-fucsia",
  "red": "Ro\u0219u",
  "red orange": "portocaliu-ro\u0219u",
  "saturation": "Satura\u021Bie",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " transparent");
  },
  "very dark": "foarte \xEEnchis",
  "very light": "foarte deschis",
  "vibrant": "plin de via\u021B\u0103",
  "white": "alb",
  "yellow": "galben",
  "yellow green": "galben-verde"
};
export { $dc46bea2f2597899$exports as default };